<!--
 * @Author: zl
 * @Date: 2022-08-24 10:30:50
 * @LastEditTime: 2022-09-05 17:58:59
 * @LastEditors: zl
 * @Description: 工地管理
-->
<template>
	<div class='WisdomSite-layout'>
		<div class="content-box"
			 v-loading="loading">
			<iframe ref="stfIframe"
					:src="iframeUrl"
					@load="sendMessage"
					frameborder="0"
					id="iframePage"
					width="100%"
					height="100%"></iframe>
		</div>
	</div>
</template>

<script>
import { selectAllUrl } from 'api/home/homeIndex'
export default {
	props: {},
	components: {},
	data() {
		return {
			loading: true,
			iframeUrl: '',
		}
	},
	created() {},
	mounted() {
		// 获取iframe的url
		this.getUrl()
	},
	methods: {
		sendMessage() {},

		// 获取iframe的url
		getUrl() {
			selectAllUrl({})
				.then((res) => {
					let list = res.data.filter(
						(x) => x.parameterKey == 'gdglUrl'
					)
					this.iframeUrl = list[0].parameterValue
					const iframeRef = this.$refs.stfIframe
					// IE和非IE浏览器，监听iframe加载事件不一样，需要兼容
					const that = this
					if (iframeRef.attachEvent) {
						// IE
						iframeRef.attachEvent('onload', () => {
							that.stateChange()
						})
					} else {
						// 非IE
						iframeRef.onload = function () {
							that.stateChange()
						}
					}
				})
				.catch((err) => {})
		},

		// loadingchange
		stateChange() {
			this.loading = false
		},
	},
	computed: {
		// iframe 地址
		// iframeUrl() {
		// let projectName = this.projectInfo.sname || '梧桐苑一期工程'
		// let userName = this.userInfo.sname
		// let token = this.$getSessionItem('token') || ''
		// let limitId = this.$getSessionItem('limitId') || ''
		// 是否是审计主体
		// let source = limitId === '1382233569480044661' ? 1 : 2
		// 线上版本
		// let url = this.$analysisUrl
		// let linkUrl = `https://xmgl.glodon.com/cas/login?type=pw&auth=F72D37FBE2AE23EAC6CB1D3298F274A463CD31FCDA705FA129B13CEDA45793078C93C057D48ADC45B1FAFF018ACE3CC8C0AF5F7B6F563ADFE1063F999733C060CE15CDE3642968C9102230CBBCA261FB495E3AEEEF45DE45CE97DDD8F9E75491DE28C4717848F27379B0A1BC739F4579CC6F57219006D8E5730E14D2B5D06E9ECCA8616B7D47676CFB6BE3992980A6D03C1A843E5BA68FD89D49982C534005A966D4BE7E8F2C9220C05106A4D68A0D5A2524E79522791D70C04592AB1448908750D5760F2AC629512B3278629D414EE13EB4A7ECE71EFFDE1D84DE3D85DB8D8422E575DF9CAB56D954B8199C11CBABD0DBA4854C796563E8697B8D1DCE34C8DC4967C69632BD6E98C91C1D6BF78E7850&service=https://xmgl.glodon.com/identification/authenticate?type=cas`
		// 本地调试地址
		// let url = "http://172.16.0.14:8220/";
		// let linkUrl = `${url}/#/projectAnalysis?projectId=${this.projectId}&source=${source}&tabName=baseInfo&noHeader=true&projectName=${projectName}&userName=${userName}&token=${token}&limitId=${limitId}`;
		// return linkUrl
		// },
	},
}
</script>

<style lang='less' scoped>
.WisdomSite-layout {
	height: 100%;
	.content-box {
		height: 100%;
	}
}
</style>